import React, { useEffect, useState } from "react";

import Message from "../../Message";
import SuccessRes from "../SuccessRes";
import { addTransferSchema } from "../../../../joi/transferSchema";
import { createTransferSetData } from "../../../../../context/api/transfers/create-transfer/createTransferSetData";
import { useValidator } from "react-joi";
import { useCookies } from "react-cookie";
import { joiErrorMessage } from "../../../extra/joiErrorMessage";
// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const CreateTransferModal = ({
  show,
  onHide,
  lang,
  dataTranslate,
  setRefreshData,
  allCustomers,
  customerId,
}) => {
  var schema = addTransferSchema(lang).schema;

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };

  const { state, setData, setExplicitField, validate, reset } =
    useValidator(schema);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [cookies] = useCookies();
  const [btnLoader, setBtnLoader] = useState(false);

  useEffect(() => {
    if (customerId) {
      setData((old) => ({
        ...old,
        customer_id: customerId,
      }));
    }
  }, []);

  const createTransfer = (e) => {
    e.preventDefault();

    let credintial = {
      customer_id: state.$data.customer_id,
      totalAmount: state.$data.totalAmount,
      feesRates: state.$data.feesRates,
      currency: state.$data.currency,
      NB: state.$data.NB,
    };

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return createTransferSetData(
        lang,
        setMessageResponse,
        cookies,
        credintial,
        setSuccessMessage,
        setBtnLoader
      );
    }
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="forget-pass-otp-form"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {successMessage.success ? (
          <SuccessRes
            lang={lang}
            dataTranslate={dataTranslate}
            onHide={async () => {
              await onHide();
              setSuccessMessage(initialSuccessMessage);
              setRefreshData((prev) => prev + 1);
            }}
            res={successMessage}
          />
        ) : (
          <>
            <Modal.Header className="d-flex align-items-center justify-content-center ">
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="fs-2 d-flex flex-row gap-2"
              >
                <span>{dataTranslate.popups.create_transfer.title}</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="mx-5">
              <div dir={lang === "AR" ? "rtl" : ""}>
                <Container>
                  {allCustomers ? (
                    <Row className="mb-lg-3">
                      <Col lg={12} sm={12} className="mb-3 mb-lg-0">
                        <Form.Group>
                          <Form.Label>
                            {
                              dataTranslate.popups.create_transfer
                                .select_customer
                            }
                            <span>
                              <sup style={{ color: "red" }}> *</sup>
                            </span>
                          </Form.Label>

                          <Form.Select
                            onBlur={() => setExplicitField("customer_id", true)}
                            onChange={(e) => {
                              setData((old) => ({
                                ...old,
                                customer_id: e.target.value,
                              }));
                            }}
                            aria-label="Default select example"
                          >
                            <option selected disabled>
                              {
                                dataTranslate.popups.create_transfer
                                  .select_customer
                              }
                            </option>
                            {allCustomers.map((item, index) => {
                              return (
                                <option key={index} value={item.id}>
                                  {item.fullName}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Form.Group>
                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.customer_id)}
                        </Form.Text>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}

                  <Row className="mb-lg-3">
                    <Col lg={4} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_transfer.amount}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              totalAmount: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("totalAmount", true)}
                        />
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.totalAmount)}
                      </Form.Text>
                    </Col>

                    <Col lg={4} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_transfer.fees}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              feesRates: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("feesRates", true)}
                        />
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.feesRates)}
                      </Form.Text>
                    </Col>

                    <Col lg={4} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_transfer.currency.title}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>

                        <Form.Select
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              currency: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("currency", true)}
                        >
                          <option selected>
                            {dataTranslate.popups.create_transfer.select}
                          </option>
                          <option value="840">
                            {dataTranslate.popups.create_transfer.currency.usd}
                          </option>
                          <option value="156">
                            {dataTranslate.popups.create_transfer.currency.rmb}
                          </option>
                        </Form.Select>
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.currency)}
                      </Form.Text>
                    </Col>
                  </Row>

                  <Row className="mb-lg-3">
                    <Col lg={12} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_transfer.notes}
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          placeholder={
                            dataTranslate.popups.create_transfer.notes
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              NB: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("NB", true)}
                        />
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.NB)}
                      </Form.Text>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Modal.Body>
            <Modal.Footer
              className="w-100 d-flex flex-row align-items-center"
              dir="ltr"
            >
              <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                <Button
                  onClick={(e) => {
                    validate();
                    createTransfer(e);
                  }}
                  disabled={btnLoader ? true : false}
                >
                  {dataTranslate.popups.create_transfer.add}
                </Button>

                <Button
                  onClick={() => {
                    reset();
                    onHide();
                  }}
                >
                  {dataTranslate.popups.create_transfer.close}
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default CreateTransferModal;
